// Components==============
import { usePermission } from 'hooks/usePermission';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext } from 'react';
import { DeleteModalContext } from '../../DeleteModal';
import './Top.module.scss';
// =========================

export default function Top() {
  const translate = useTranslate();

  const { deleteCondition } = useContext(ProjectDetailsContext);
  const { ownerOfPublicTheme, shouldTransfer } = useContext(DeleteModalContext);

  const isTeacher = usePermission(['Docent', 'super-admin']);

  const teacherLeavesProject = !shouldTransfer && isTeacher;

  return (
    <>
      <img src="/images/trash.svg" alt="trash" styleName="image" />
      <h1 styleName="title">
        {translate(
          `project.groupswork-popups.delete-popup.title${
            deleteCondition ? '1' : '2'
          }`
        )}
      </h1>
      {!!ownerOfPublicTheme && (
        <p styleName="description">
          {translate('project.actions.delete-theme')}:
          <br />
          {translate('project.actions.delete-description-2')}{' '}
          <a href="mailto:groow@studiotast.com">groow@studiotast.com</a>
        </p>
      )}
      {!teacherLeavesProject && (
        <p>
          {shouldTransfer
            ? translate(
                `${'project.groupswork-popups.delete-popup.description2'}`
              )
            : translate('project.groupswork-popups.delete-popup.description1')}
        </p>
      )}
    </>
  );
}
